import { PollRepository } from '../../data/local/pollRepository'
import { caravanDb } from '../../services/syncRuntime'

export const pollRepository = new PollRepository(caravanDb)
